import { mapActions } from 'vuex'
import Croppie from '@/shared/components/Croppie'

export default {
  components: { Croppie },
  props: {
    overlay: {
      type: Object,
      default() {
        return {
          component: '',
          data: {},
        }
      },
    },
  },
  methods: {
    ...mapActions('landing', ['updateOptions']),
    ...mapActions('ui', ['setOverlay']),
  },
}
